import axios from 'api/axios'
import { useEffect, useState } from 'react'

const useFetchMisEvaluaciones = (viewAsAdmin) => {
  const [response, setResponse] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    setLoading(true) // Sincrónico → skeleton aparece inmediatamente
    setResponse([]) // Limpiar datos anteriores

    const fetchData = async () => {
      try {
        const url = viewAsAdmin ? '/desempeno_procesos_admin/' : '/desempeno/?a=False'
        const result = await axios.get(url)
        setResponse(result.data)
      } catch (err) {
        setError(err.response?.data || err.message || 'Error al cargar los datos')
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [viewAsAdmin])

  return { response, loading, error }
}

export default useFetchMisEvaluaciones
